export const articles = [

    {
    id: 1,
    source: "The Jerusalem Post",
    logo: "JPost",
    title: "How ActionAI's Miriam Haart is shaping the future of reliable AI",
    url: "https://www.jpost.com/podcast/article-892143",
  },
  {
    id: 2,
    source: "The JC",
    logo: "TheJC",
    title: "How Miriam Haart's life took another unorthodox turn at a Tel Aviv AI startup",
    url: "https://www.thejc.com/news/features/how-miriam-haarts-life-took-another-unorthodox-turn-at-a-tel-aviv-ai-startup-jai8v9z7",
  },
  {
    id: 3,
    source: "Biz Journals",
    logo: "BizJournals",
    title: "Miriam Haart: From Unorthodox Life to Leading AI Innovation",
    url: "https://www.bizjournals.com/bizwomen/news/profiles-strategies/2026/03/miriam-haart-unorthodox-life-actionai.html",
  },
  {
    id: 5,
    source: "Jewish News",
    logo: "JewishNews",
    title: "Miriam Haart: 'My religion is trying to get women to believe in themselves'",
    url: "https://www.jewishnews.co.uk/unorthodox-ambition-from-netflix-screens-to-building-machines/",
  },
  {
    id: 4,
    source: "Time Out",
    logo: "TimeOut",
    title: "Entrepreneur Miriam Haart is On a Quest To Shake Up Tech",
    url: "https://www.timeout.com/san-francisco/things-to-do/future-seekers-miriam-haart",
  },
  {
    id: 10,
    source: "The Jerusalem Post",
    logo: "JPost",
    title: "Jerusalem's Young Professionals event brings together experts to discuss tech careers in AI age",
    url: "https://www.jpost.com/business-and-innovation/tech-and-start-ups/article-883499",
  },
  {
    id: 6,
    source: "Stanford Daily",
    logo: "Stanford",
    title: "CS teacher Miriam Haart '22 discusses the impact of computer science",
    url: "https://stanforddaily.com/2019/02/05/qa-cs-teacher-miriam-haart-22-discusses-the-impact-of-computer-science/",
  },
  {
    id: 7,
    source: "Israel Defense",
    logo: "IsraelDefense",
    title: "Israeli startup raises $10M to bridge AI trust gaps",
    url: "https://www.israeldefense.co.il/node/68683",
  },
  {
    id: 8,
    source: "The Jerusalem Post",
    logo: "JPost",
    title: "From reality TV to pro-Israel activism",
    url: "https://www.jpost.com/israel-news/culture/article-714225",
  },
  {
    id: 9,
    source: "Girls Who Code",
    logo: "GirlsWhoCode",
    title: "LGBTQ+ Leaders Making Waves In STEM",
    url: "https://www.instagram.com/girlswhocode/guide/lgbtq-leaders-making-waves-in-stem/18212086285195586/",
  },

  // {
  //   id: 9,
  //   source: "Ms. Magazine",
  //   logo: "MsMagazine",
  //   title: "I will not be overturned: An NFT collection to combat the removal of Roe V. Wade",
  //   url: "https://msmagazine.com/2022/06/15/my-unorthodox-life-miriam-haart-nft-abortion-roe-v-wade-jewish/",
  // },
  // {
  //   id: 10,
  //   source: "4i-mag",
  //   logo: "4iMag",
  //   title: "How to become a woman tech entrepreneur at a young age",
  //   url: "#",
  // },
  {
    id: 11,
    source: "NYLON",
    logo: "Nylon",
    title: "My Unorthodox Life, A Reality TV Hit",
    url: "https://www.nylon.com/life/my-unorthodox-life-miriam-batsheva-haart",
  },

];
